import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
    Visibility,
    Add
} from "@mui/icons-material";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    adderReset,
    DeleteAddreMethod,
    GetAllAdders,
} from "../../Redux/AddersSlicev2/AddersSlicev2";
import AdderStatusConfirm from "./AdderStatusConfirm";
import EditAdderv2 from "./EditAdderv2";
import { useParams } from "react-router-dom";

const AllAddersv2Childs = () => {
    const { parent_id } = useParams();

    const dispatch = useDispatch();
    // Pop Up Data
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    //edit row
    const [edit, setEdit] = useState(false);
    const handelOpenEditRow = (data) => {
        setData(data);
        setEdit(true);
    };
    const handelCloseEditRow = () => {
        setData({});
        setEdit(false);
    };

    // Delete Adder Confirm

    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success("Adder deleted success");
        await GetAllAddersAction();
        await dispatch(adderReset());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteAddreMethod(data.id));
        await CallNotificationMethod();
        await setTableId(data.id);
    };
    const handelDeleteAdder = async (data) => {
        handleOpen(data);
    };

    const { adders, isSuccess, isLoading, isError, errors } = useSelector(
        (state) => state.addersv2
    );
    const AllAddersVal = adders?.data?.data || [];
    const AdderPag = adders?.data || [];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                GetAllAdders({
                    paginate: rowsPerPage,
                    page: newPage + 1,
                    parent_id: parent_id || 0
                })
            );
            await dispatch(adderReset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(GetAllAdders({ paginate: event.target.value }));
            await dispatch(adderReset());
        };
        callSearchAction();
    };

    const GetAllAddersAction = async () => {
        await dispatch(
            GetAllAdders({
                paginate: rowsPerPage,
                page: page + 1,
                parent_id: parent_id || 0
            })
        );
    };
    useEffect(() => {
        GetAllAddersAction();
    }, []);
    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const reset = async () => {
                await dispatch(adderReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    // Change Adder Status

    const [status, setStatus] = useState(false);

    const handelOpenStatusRow = (data) => {
        setData(data);
        setStatus(true);
    };

    const handelCloseStatusRow = () => {
        setData({});
        setStatus(false);
    };

    useEffect(() => {
        // console.log(isSuccess);
    }, [isSuccess]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell> Adder Name</TableCell>
                                <TableCell> Status </TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {AllAddersVal?.map((key, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>
                                        {index + 1}
                                        {/* {rowsPerPage * page + index + 1} */}
                                    </TableCellStyle>
                                    <TableCellStyle>{key?.name}</TableCellStyle>
                                    <TableCellStyle>
                                        {parseInt(key.status) !== 0 ? (
                                            <span style={{ color: "green" }}>
                                                Active
                                            </span>
                                        ) : (
                                            <span>Inactive</span>
                                        )}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        <IconButton>
                                            <Link to={"/dashboard/adders/v2/edit=" + key.id}>
                                                <Edit color="success" />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={(e) =>
                                                handelDeleteAdder(key)
                                            }
                                        >
                                            <Link to={"#"}>
                                                <Delete color="error" />
                                            </Link>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                        <TableHeadStyled>
                            <TableRow>
                                {AdderPag.total >= 15 && (
                                    <TablePagination
                                        rowsPerPageOptions={[
                                            15,
                                            50,
                                            100,
                                            { label: "All", value: -1 },
                                        ]}
                                        colSpan={12}
                                        count={AdderPag.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </TableRow>
                        </TableHeadStyled>
                    </Table>

                    {/* EDIT MODAL  */}
                    <PopupModal open={edit} close={handelCloseEditRow}>
                        <EditAdderv2 data={data} />
                    </PopupModal>

                    {/* Update Adder Status MODAL  */}
                    <PopupModal open={status} close={handelCloseStatusRow}>
                        <AdderStatusConfirm
                            data={data}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            status={setStatus}
                            close={handelCloseStatusRow}
                        />
                    </PopupModal>

                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllAddersv2Childs;
